import React, { useEffect, useState } from "react";
import * as S from "./styles";
import {
  VisibilityButton
} from "components/Buttons/ActionButton";
import { scrollToTop } from "utils";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { Tooltip } from "@mui/material";
import { brDate } from "utils/formatDate";

import AgentCity from "utils/agentCity";
import AgentType from "utils/agentType";

// #745: competencia (mes de referencia) gravada pela API; folhas antigas nao
// tem e usam o mes de created_at, que era o que ia no AnoMes_Parcela do CSV.
const competenciaDe = (payroll) =>
  (payroll.competencia ?? payroll.created_at)?.slice(0, 7);

const formatCompetencia = (anoMes) =>
  anoMes ? `${anoMes.slice(5, 7)}/${anoMes.slice(0, 4)}` : "Não informado";

// Meses sem folha e meses com mais de uma folha entre as folhas listadas.
// Folha vazia (sem registros, ex.: duplicata abortada) nao conta.
const checarCompetencias = (payrolls) => {
  const contagem = payrolls
    .filter((payroll) => payroll.total_value)
    .map(competenciaDe)
    .filter(Boolean)
    .reduce((acc, anoMes) => ({ ...acc, [anoMes]: (acc[anoMes] || 0) + 1 }), {});

  const meses = Object.keys(contagem).sort();
  const duplicadas = meses.filter((anoMes) => contagem[anoMes] > 1);
  const faltantes = [];
  for (let i = 1; i < meses.length; i++) {
    let [ano, mes] = meses[i - 1].split("-").map(Number);
    for (;;) {
      mes += 1;
      if (mes > 12) {
        mes = 1;
        ano += 1;
      }
      const anoMes = `${ano}-${String(mes).padStart(2, "0")}`;
      if (anoMes >= meses[i]) break;
      faltantes.push(anoMes);
    }
  }
  return { duplicadas, faltantes };
};

const TablePayroll = ({
  payrollList,
  page = 1,
  totalPages,
  setPage,
}) => {
  const [sortedPayrollList, setSortedPayrollList] = useState([]);
  const agent_type = AgentType();
  const agent_city = AgentCity();

  const handleChange = (event, value) => {
    if (value !== page) {
      setPage(value);
      scrollToTop();
    }
  };
  
  useEffect(() => {
    if (payrollList?.length > 0) {
      const orderedList = payrollList
        .slice()
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Ordena do mais recente para o mais antigo

      setSortedPayrollList(orderedList);
    }
  }, [payrollList]);
  
   

  const { duplicadas, faltantes } = checarCompetencias(sortedPayrollList);

  return (
    <S.TableContainer>
      <S.CabecalhoTabela>
        <Typography variant="h6" style={{ marginTop: 0, marginBottom: 0 }}>
          Lista das folhas de pagamento
        </Typography>
      </S.CabecalhoTabela>

      {(faltantes.length > 0 || duplicadas.length > 0) && (
        <Typography role="alert" style={{ color: "#B42318", marginBottom: 12 }}>
          {faltantes.length > 0 &&
            `Competência sem folha nesta página: ${faltantes.map(formatCompetencia).join(", ")}. `}
          {duplicadas.length > 0 &&
            `Competência com mais de uma folha: ${duplicadas.map(formatCompetencia).join(", ")}.`}
        </Typography>
      )}

      <S.StyledTable>
        <S.StyledTableHead>
          <tr>
            <S.StyledTableHeaderCell>Competência</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>Período de consulta</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>Total de beneficiários</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>Ação</S.StyledTableHeaderCell>
          </tr>
        </S.StyledTableHead>
        <S.StyledTableBody>
          {sortedPayrollList?.map((payroll) => {
            const { id, created_at, total_value, total_value_per_city  } = payroll;

            // Definir o valor a ser exibido
            let displayedTotalValue = "Não informado";
            
            if (agent_type === "1" || agent_type === "4" || agent_type === "6") {
              displayedTotalValue = total_value ?? "Não informado";
            } else {
              const city = agent_city;
              if (city && total_value_per_city) {
                displayedTotalValue = total_value_per_city[city] ?? "Não informado";
              }
            }

            return (
              <S.StyledTableRow key={id}>
                <S.StyledTableCell>
                  {formatCompetencia(competenciaDe(payroll))}
                  {!total_value && " (vazia)"}
                </S.StyledTableCell>
                <S.StyledTableCell>
                  {brDate(created_at)}
                </S.StyledTableCell>
                <S.StyledTableCell>{displayedTotalValue}</S.StyledTableCell>


                <S.StyledTableCell>
                  <S.ButtonsContainer>
                  <Tooltip title="Visualizar folha">
                    <Link to={`/gestao/folha/${id}`}>
                      <VisibilityButton />
                    </Link>
                  </Tooltip>
                  </S.ButtonsContainer>
                </S.StyledTableCell>
              </S.StyledTableRow>
            );
          })}
        </S.StyledTableBody>
      </S.StyledTable>

      <S.TableFooter>
        <Typography>
          Página {page} de {totalPages}
        </Typography>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChange}
          renderItem={(item) => (
            <PaginationItem
              slots={{ previous: WestIcon, next: EastIcon }}
              {...item}
            />
          )}
        />
      </S.TableFooter>
    </S.TableContainer>
  );
};

export default TablePayroll;
